import React from 'react';
import { Drawer, Box, List, IconButton, Divider, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import NavbarItem from '../NaviagtionBar/NavbarItem';

const MobileDrawer = ({ open, onClose, items, flatNavigationItems, onItemClick, anchor = 'left' }) => {
  const { data: domainData } = useSelector((state) => state.domainConfig);
  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  return (
    <Drawer
      key={anchor}
      anchor={anchor}
      open={open}
      onClose={onClose}
      PaperProps={{
        dir: isRtl ? 'rtl' : 'ltr',
        sx: {
          boxSizing: 'border-box',
          width: 280,
          backgroundColor: 'primary.contrastText',
          color: 'primary.main',
        }
      }}
      SlideProps={{
        direction: anchor === 'right' ? 'left' : 'right'
      }}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { xs: 'block', lg: 'none' },
      }}
    >
      <Box dir={theme.direction} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box
            component="img"
            src={domainData?.logo}
            alt="Company Logo"
            sx={{ height: 40, width: 'auto', maxWidth: 180, objectFit: 'contain' }}
          />
          <IconButton onClick={onClose} color="inherit" sx={{ ml: isRtl ? 0 : 2, mr: isRtl ? 2 : 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List sx={{ pt: 1, pb: 2 }}>
          {items?.map((item) => (
            <NavbarItem
              key={item.id}
              item={item}
              onItemClick={onItemClick}
              defaultExpanded={item.defaultExpanded}
              horizontalTreeMode={false} // Use vertical styling
              horizontal={false}
              flatNavigationItems={flatNavigationItems}
              onMenuClose={onClose}
            />
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;
